import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function LegalPage() {
  const { slug, page } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/legal/${slug}/${page}`).then((r) => setData(r.data)).catch(() => {});
  }, [slug, page]);

  if (!data) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;

  return (
    <div className="min-h-screen bg-white" data-testid="legal-page">
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-6 lg:px-12 h-16 flex items-center">
          <Link to={`/s/${slug}`} data-testid="legal-back" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground">
            <ArrowLeft className="w-4 h-4" /> {data.tenant.name}
          </Link>
        </div>
      </header>
      <article className="max-w-3xl mx-auto px-6 lg:px-12 py-14">
        <h1 className="editorial-h1 text-4xl lg:text-5xl mb-8">{data.title}</h1>
        <div className="prose prose-sm max-w-none text-foreground whitespace-pre-line leading-relaxed" data-testid="legal-body">{data.body}</div>
      </article>
    </div>
  );
}
